import React from "react";
import { useHistory } from "react-router-dom";
import "./Home.css";

function Home() {
  const history = useHistory();

  return (
    <div className="home-container">
      <h1 className="home-title">Select Application</h1>
      <div className="cards-container">
        <div className="card" onClick={() => history.push("/nia")}>
          <h2>NIA</h2>
          <p>New India Assurance — Collection &amp; Payment Reconciliation</p>
        </div>
        <div className="card" onClick={() => history.push("/ksrtc")}>
          <h2>KSRTC</h2>
          <p>PDF to Images Converter — Upload PDFs &amp; Download as ZIP</p>
        </div>
      </div>
    </div>
  );
}

export default Home;
